export default __webpack_public_path__ + "static/media/checkmark.0e7e8448.svg";